import request from "@/utils/server.js";

//************************* */ 自己的服务器 测试获取模版数据接口 待删除接口*************************
// 获取模版列表（GET方法）
export function getTemplateListAPI(params) {
  return request({
    // url: "/template/json/list",
    url: "/wxz/template/" + params.templateId,
    method: "get",
  });
}
// 保存模版列表（POST方法）
export function saveTemplateListAPI(data) {
  return request({
    url: "/template/json/save",
    method: "post",
    data,
  });
}
